import React, { createContext, useContext, useState, useEffect } from "react";

const WorkerContext = createContext();

export const WorkerProvider = ({ children }) => {
  const [selectedWorker, setSelectedWorker] = useState(null);

  useEffect(() => {
    const savedWorker = localStorage.getItem("worker");
    if (savedWorker) setSelectedWorker(JSON.parse(savedWorker));
  }, []);

  const handleSetWorker = (worker) => {
    setSelectedWorker(worker);
    localStorage.setItem("worker", JSON.stringify(worker));
  };

  return (
    <WorkerContext.Provider value={{ selectedWorker, setSelectedWorker: handleSetWorker }}>
      {children}
    </WorkerContext.Provider>
  );
};

// ✅ Unique hook
export const useServiceWorkerContext = () => useContext(WorkerContext);